module.exports = __webpack_public_path__ + "static/media/CDM.5f8a3ef3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/shgn/footerLogos/mobile/CDM.svg
// module id = 99
// module chunks = 0